import React from 'react';
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled Accordion
const StyledAccordion = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: 'white',
  border: '1px solid #e5e7eb',
  borderTop: 'none',
  boxShadow: 'none',
  '&:first-of-type': {
    borderTop: '1px solid #e5e7eb',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: '0',
    borderBottom: '1px solid #e5e7eb',
  },
}));

// Styled Accordion Summary
const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '16px 20px',
  minHeight: '56px',
  '&.Mui-expanded': {
    minHeight: '56px',
    borderBottom: '1px solid #e5e7eb',
  },
  '& .MuiAccordionSummary-content': {
    margin: '12px 0',
    '&.Mui-expanded': {
      margin: '12px 0',
    },
  },
}));

// Styled Accordion Details
const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '16px 20px 20px 20px',
  backgroundColor: '#f9fafb',
  borderTop: '1px solid #e5e7eb',
}));

// Plus Icon Component
const PlusIcon = ({ expanded }) => (
  <div
    className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
      expanded
        ? 'bg-primary-500 text-white'
        : 'bg-gray-100 text-gray-600'
    }`}
  >
    <svg
      className={`w-5 h-5 transition-transform duration-300 ${
        expanded ? 'rotate-45' : ''
      }`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M12 4v16m8-8H4"
      />
    </svg>
  </div>
);

const Accordion = ({ items }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="w-full">
      {items.map((item, index) => (
        <StyledAccordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
        >
          <StyledAccordionSummary
            expandIcon={<PlusIcon expanded={expanded === `panel${index}`} />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <p className="text-gray-900 font-semibold text-base pr-4">
              {item.question}
            </p>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <p className="text-gray-600 text-sm leading-relaxed">
              {item.answer}
            </p>
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};

export default Accordion;

